/*
 * Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
export class WorksheetExportRequest {
  fileName: string;
  headers: Map<string, string[]>;
  fieldNames: Map<string, string[]>;
  data: Map<string, any[]>;
  numTypeFields?: Map<string, string[]>;
  percentTypeFields?: Map<string, string[]>;
}
